import React from 'react';
import Stack from '../../Stack';
import { getSpacing } from '../../../../utils/spacing';
import Text from '../../Text';
import HoverDetectionContainer from '../../HoverDetectionContainer';
import { colors } from '../../../../utils/theme';

export type SelectOptionOwnProps = {
    isLast: boolean;
    primaryDisplay: string;
    subDisplay?: string;
};

export type SelectOptionProps = SelectOptionOwnProps;

const SelectOption: React.FC<SelectOptionProps> = (props) => {
    const [isHovered, setIsHovered] = React.useState(false);
    return (
        <HoverDetectionContainer onHoverChange={setIsHovered} style={{ width: '100%' }}>
            <Stack
                vertical
                fullWidth
                space={1}
                style={{
                    padding: getSpacing(4),
                    paddingTop: getSpacing(8),
                    paddingBottom: getSpacing(8),
                    backgroundColor: isHovered ? colors['Grey-Light2'] : undefined,
                    width: '100%',
                }}
            >
                <Text variant="bold-body-1" style={{ width: '100%' }} wrapText>
                    {props.primaryDisplay}
                </Text>
                {props.subDisplay && (
                    <Text variant="body-1" color="Gray-Text">
                        {props.subDisplay}
                    </Text>
                )}
            </Stack>
        </HoverDetectionContainer>
    );
};

export default React.memo(SelectOption);
